var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from '../common/Modal';
import { List, ListItemInput, ListItemSelect, ListItemTextArea, } from '@bootstraplabs/bsw-common-react';
import { getLegalTypeOptions, mapLegalTypeOptions, jurisdictionOptions, } from './helpers';
import regEx from '../../utils/regex';
import { useCreateOrganizationMutation, JurisdictionOfFormation as Jurisdiction, LegalType, refetchOrganizationsListQuery, } from '../../__generated__/graphql';
var initialState = {
    name: '',
    description: '',
    jurisdiction: Jurisdiction.US_DE,
    legalType: LegalType.INC,
};
export default function AddOrganizationModal(props) {
    // State
    var _a = useState(initialState.name), name = _a[0], setName = _a[1];
    var _b = useState(initialState.description), description = _b[0], setDescription = _b[1];
    var _c = useState(initialState.jurisdiction), jurisdiction = _c[0], setJurisdiction = _c[1];
    var _d = useState(initialState.legalType), legalType = _d[0], setLegalType = _d[1];
    // Legal type options
    var legalTypeOptions = mapLegalTypeOptions(jurisdiction);
    // Mutations
    var createOrganization = useCreateOrganizationMutation({
        variables: {
            input: {
                jurisdictionOfFormation: jurisdiction,
                legalType: legalType,
                name: name.trim(),
                description: description.trim(),
            },
        },
        refetchQueries: [refetchOrganizationsListQuery()],
    })[0];
    // Event handlers
    var updateJurisdiction = function (j) {
        var ltOptions = getLegalTypeOptions(j);
        var legalTypeAllowed = Reflect.has(ltOptions, legalType);
        if (!legalTypeAllowed) {
            setLegalType(LegalType.INC);
        }
        setJurisdiction(j);
    };
    var confirm = function () {
        void createOrganization();
        // Reset to initial states
        setName(initialState.name);
        setDescription(initialState.description);
        setJurisdiction(initialState.jurisdiction);
        setLegalType(initialState.legalType);
        // Close dialog
        props.onCancel();
    };
    var cancel = function () {
        // Close dialog without resetting states
        props.onCancel();
    };
    return (_jsx(Modal, __assign({ "data-test": "modal-create-organization", title: "Add company", open: props.open, onCancel: cancel, onConfirm: confirm, disabled: !name ||
            (name && regEx.trimmedString.test(name.trim())) === false ||
            name.trim().length < 1 ||
            name.trim().length > 100 ||
            !description ||
            description.trim().length > 1000 ||
            // Note: The textInput will only accept 1000 characters and cut the text after 1000 char.
            // Consequently the disable function will not be utilized as long as
            // a supported browser is used, and the HTMLInputElement is displayed as expected.
            description.trim().length < 1 ||
            !legalType ||
            !jurisdiction }, { children: _jsxs(List, { children: [_jsx(ListItemInput, { labelWidth: 200, type: "text", label: "Name", value: name, onChange: setName, placeholder: "My Company Inc." }, void 0),
                _jsx(ListItemTextArea, { label: "Description", value: description, onChange: setDescription, placeholder: "Description of My Company Inc." }, void 0),
                _jsx(ListItemSelect, { labelWidth: 200, label: "Jurisdiction of formation", value: jurisdiction, onChange: function (val) { return updateJurisdiction(val); }, options: jurisdictionOptions }, void 0),
                _jsx(ListItemSelect, { labelWidth: 200, label: "Legal type", value: legalType, onChange: function (val) { return setLegalType(val); }, options: legalTypeOptions }, void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=AddOrganizationModal.js.map